import { theme } from '@frontend/theme';
import { ModalControlModalProps, TableFilters, Tabs } from '@frontend/design-system';
import { DeptFilters } from './filters/filters-department';
import { FiltersTable } from './filters/filters-table';
import { YourGroupsFilters } from './filters/filters-your-groups';

type Props = {
  modalProps: ModalControlModalProps;
  setShowNotificationBadge: (showNotification: boolean) => void;
};

export const FeatureFlagTableFilters = ({ modalProps, setShowNotificationBadge }: Props) => {
  return (
    <TableFilters
      headerLabel='All Filters'
      {...modalProps}
      onApplyClick={() => {
        setShowNotificationBadge(true);
      }}
      width='medium'
    >
      <TableFilters.Section sectionHeaderLabel=''>
        <Tabs initialTab='table'>
          <Tabs.Bar fullWidth={true} css={{ marginBottom: theme.spacing(2) }}>
            <Tabs.Tab id='filters-table'>Filter Table</Tabs.Tab>
            <Tabs.Tab id='filter-departments'>Filter Departments</Tabs.Tab>
            <Tabs.Tab id='filters-your-groups'>Your Groups</Tabs.Tab>
          </Tabs.Bar>
          <Tabs.Panel controller='filters-table'>
            <FiltersTable />
          </Tabs.Panel>
          <Tabs.Panel controller='filters-departments'>
            <DeptFilters />
          </Tabs.Panel>
          <Tabs.Panel controller='filters-your-groups'>
            <YourGroupsFilters />
          </Tabs.Panel>
        </Tabs>
      </TableFilters.Section>
    </TableFilters>
  );
};
